module.exports = __webpack_public_path__ + "img/Large-Semi-Elliptical-Attachment-R-32.f2788b14.png";